
window.addEventListener("load", function(){
	//Add form field in delay

	const forms = document.querySelectorAll('form[method="post"]');
	
	forms.forEach(function(form_obj){
		setTimeout( function(){
			form_obj.addEventListener('focusin', function(event){
				
				const hidden_fields = form_obj.querySelector('div[style="display: none;"]');
				
				if(form_obj.querySelector('input[name="_dhfbf05d449y4e4vt13phodq"]')){
					//already has the field
				} else {
					hidden_fields.innerHTML += '<input type="hidden" name="_dhfbf05d449y4e4vt13phodq" value="vpuMuuj9*IrrqhFHohoHaXMrhdy4t*$0^WZzjyqohcZh#7^!n1f4o^Yr@EUpbrP5&zb3aoj2XZtu@2!@CbCMS@cPDi3lzOa%W5DH$%MaYUdth^1cxBexI9fAyE6l92JVgPK50eBq6#Wy5zcd@C0472" />';
				}
				const bot_id = form_obj.querySelector('input[name="t6dEMr05HOJ5ZQHcR8uapP"]');
				if(bot_id){
					bot_id.remove();
				}
			});
		}, 500);
	});
}, true);


// WEBPACK FOOTER //
// ./assets/js/general/a-honeypot.js